import type { DeviceType, ExternalSeatData } from '../models/types';

export type RawSeatSchemaEntry = {
  centerX?: number;
  centerY?: number;
  x?: number | string;
  y?: number | string;
  id?: number | string;
  sectorName?: string;
  row?: number | string;
  rowName?: number | string;
  seat?: number | string;
  seatName?: number | string;
  [key: string]: unknown;
};

export const normalizeExternalSeats = (data: RawSeatSchemaEntry[] = []): ExternalSeatData[] => {
  return data.map(it => {
    const centerX = typeof it.centerX === 'number' ? it.centerX : Number(it.x) || 0;
    const centerY = typeof it.centerY === 'number' ? it.centerY : Number(it.y) || 0;

    let id: string = String(it.id || '');

    if (!id && it.sectorName && (it.row ?? it.rowName) && (it.seat ?? it.seatName)) {
      const sector = String(it.sectorName);
      const row = String(it.row ?? it.rowName);
      const seat = String(it.seat ?? it.seatName);
      id = `seatcontainer.sector.${sector}.row.${row}.seat.${seat}`;
    }

    return { centerX, centerY, id } as ExternalSeatData;
  });
};

export const mapDeviceTypeToParam = (deviceType: DeviceType) => {
  return deviceType === 'mobile' ? 1 : 0;
};
